/**
 * Validation map for the brand-details form.
 *
 * `REQUIRED_FIELDS` keys are dotted paths (so nested `bank_info.X`
 * fields are addressable with the same shape as flat top-level ones).
 * `TAB_FOR_FIELD` lets the submit handler jump to the right tab when a
 * required field is missing and the user is on a different tab.
 */
export const REQUIRED_FIELDS = {
  name: 'Brand name is required',
  domain: 'Brand domain is required',
};

// Bank details are deliberately NOT required. They are payout information —
// they matter when a brand first takes money, not when it is created or when
// someone edits its name. The backend agrees: every `bank_info` field on the
// brand_profile model is a plain optional String. Requiring them here also
// locked existing brands with no bank details out of saving any other change.
// If payouts ever need to be gated, gate them at the payout step.

/**
 * Tab display names, indexed to match `TAB_FOR_FIELD`. Shared by the tab bar
 * and by the disabled-Submit explanation, so a renamed tab cannot drift out
 * of sync with the message that points at it.
 */
export const TAB_LABELS = ['Information', 'Logo', 'Bank Info'];

export const TAB_FOR_FIELD = {
  name: 0,
  domain: 0,
};

export const getFieldValue = (data, path) => {
  if (!path.includes('.')) return data?.[path];
  const [parent, child] = path.split('.');
  return data?.[parent]?.[child];
};

/**
 * Map backend error messages to user-readable copy. The defaults from
 * the brand controller are aimed at debugging, not customers — we
 * sandpaper them here.
 */
export const friendlyError = (raw) => {
  if (!raw) return 'Something went wrong. Please try again.';
  const text = typeof raw === 'string' ? raw : raw.message || JSON.stringify(raw);
  if (/Missing user_id or brand_id/i.test(text)) return 'Please fill in all required fields and try again.';
  if (/brandId is required/i.test(text))         return 'Please fill in all required fields and try again.';
  if (/company already exist/i.test(text))         return 'A brand with this domain already exists.';
  if (/permission/i.test(text))                     return 'You do not have permission to do this.';
  return text;
};
